module.exports = __webpack_public_path__ + "img/magnifying-glass-shadow.c1f90e48.svg";